import { Flag, FlagFilled } from "components/icons/generated";
import { IconColors } from "ds/components/Icon/types";
import { IconComponent } from "types/Icon";
import { RunPriorityPreset } from "types/generated";

type RunPriorityPresetConfig = {
  icon: IconComponent;
  color: IconColors;
  label: string;
};

export const RUN_PRIORITY_PRESETS: Record<RunPriorityPreset, RunPriorityPresetConfig> = {
  [RunPriorityPreset.High]: { icon: FlagFilled, color: "danger", label: "High priority" },
  [RunPriorityPreset.Normal]: { icon: Flag, color: "primary", label: "Normal priority" },
  [RunPriorityPreset.Low]: { icon: FlagFilled, color: "tertiary", label: "Low priority" },
};

// Object key order is not a contract, so the render order is declared separately.
export const RUN_PRIORITY_PRESET_ORDER: RunPriorityPreset[] = [
  RunPriorityPreset.High,
  RunPriorityPreset.Normal,
  RunPriorityPreset.Low,
];
